module.exports = __webpack_public_path__ + "static/questions-background-047690672441473c39700f6dd6a54618.png";